import { endpoint, secrets } from '@chilipiper/config'

export const x = (uri = '') => `${endpoint.x()}${uri}`
export const api = (uri = '') => `${endpoint.api()}${uri}`
export const reportingApi = (uri = '') => `${endpoint.reporting()}${uri}`
export const inboxApi = (uri = '') => `${endpoint.inbox()}${uri}`
export const edge = (uri = '') => `${endpoint.edge()}${uri}`
export const homebase = (uri = '') => `${endpoint.homebase()}${uri}`
export const qa = (uri = '') => `${endpoint.qa()}${uri}`
export const profiles = (uri = '') => `${endpoint.profiles()}${uri}`
export const profilesUpload = (uri = '') => `${endpoint.profilesUpload()}${uri}`
export const backoffice = (uri = '') => `${endpoint.backoffice()}/api/v1${uri}`
export const extensionId = () => secrets.extensionId
export const ib = (uri = '') => `${endpoint.ib()}${uri}`
export const newIb = (uri = '') => `${endpoint.newInstantBooker()}${uri}`
